import React from "react";
import "./ConfirmDialog.css";

// Controlled component (isOpen/onConfirm/onCancel), matching how the rest of
// this codebase manages modal-ish UI as local page state rather than through
// a global context.
const ConfirmDialog = ({
  isOpen,
  title = "Are you sure?",
  message,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  danger = false,
  onConfirm,
  onCancel,
}) => {
  if (!isOpen) return null;

  return (
    <div className="confirm-dialog-overlay" onClick={onCancel}>
      <div className="confirm-dialog" onClick={(e) => e.stopPropagation()}>
        <h3 className="confirm-dialog-title">{title}</h3>
        {message && <p className="confirm-dialog-message">{message}</p>}
        <div className="confirm-dialog-actions">
          <button type="button" className="vt-btn vt-btn-purple" onClick={onCancel}>
            {cancelLabel}
          </button>
          <button
            type="button"
            className={`vt-btn ${danger ? "vt-btn-danger" : "vt-btn-primary"}`}
            onClick={onConfirm}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;
